import { createRef, useState } from 'react';
import { useRouter } from 'next/router';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FormInput from 'components/FormInput';
import cleanObject from 'utils/clean-object';

const handleOnChange = (e) => {
  const node = e.target;
  if (e.nativeEvent.inputType) {
    const { value } = node;
    const sanitized = value.replace(/\D/g, '');
    node.value = sanitized === '' ? '' : `$ ${sanitized}`;
  }
};

function PriceRangeFilter({ facet, filterParam, path, promotion }) {
  const router = useRouter();
  const formRef = createRef();
  const CUSTOM_PRICE_RANGE = 'CUSTOM_PRICE_RANGE_';

  const [submitError, setSubmitError] = useState(null);

  let defaultMin = '';
  let defaultMax = '';

  const customerRangeParam = filterParam
    .split(',')
    .filter((param) => param.includes(CUSTOM_PRICE_RANGE));

  if (customerRangeParam.length > 0) {
    const splitFilter = customerRangeParam[0].split(CUSTOM_PRICE_RANGE);
    const splitPrices = splitFilter[1].split('_');
    defaultMin = splitPrices.length === 2 ? `$ ${splitPrices[0]}` : '';
    defaultMax = splitPrices.length === 2 ? `$ ${splitPrices[1]}` : '';
  }

  const onSubmit = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const {
      min_price_filter: { value: minPriceString },
      max_price_filter: { value: maxPriceString },
    } = e.target.elements;

    const parsedMin = Number.parseInt(minPriceString.replace('$ ', ''), 10);
    const parsedMax = Number.parseInt(maxPriceString.replace('$ ', ''), 10);
    const minPriceInt = Number.isNaN(parsedMin) ? 0 : parsedMin;
    const maxPriceInt = Number.isNaN(parsedMax) ? 0 : parsedMax;

    if (maxPriceInt < minPriceInt) {
      setSubmitError('Min price must be less than max price');
      return;
    }

    setSubmitError(null);

    const term = `${CUSTOM_PRICE_RANGE}${minPriceInt}_${maxPriceInt}`;
    const paramValue = encodeURIComponent(`${facet}^term^${term}`);
    const paramsArray = filterParam.split(',');

    const updatedParams = paramsArray.filter((param) => {
      const familyParam = encodeURIComponent(`${facet}^term`);
      const isSameFamily = param.includes(familyParam);

      return !isSameFamily;
    });

    updatedParams.push(paramValue);

    const filterQueryParam = updatedParams.join(',');
    const sanitizedQuery = cleanObject({
      sort: router.query.sort,
      filters: filterQueryParam,
      promotion,
      search: router.query.search,
    });

    router.push(
      {
        pathname: path,
        query: sanitizedQuery,
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <Form
        ref={formRef}
        id="price_range_filter_form"
        className="bg-transparent d-flex flex-row lh-1"
        onSubmit={onSubmit}
      >
        <FormInput
          required
          className="bg-transparent text-primary border-primary"
          controlId="min_price_filter"
          defaultValue={defaultMin}
          feedbackStyles="bg-white fs-5 fw-600 p-2"
          formGroupClassName="text-primary border-primary me-5"
          label="Min $"
          placeholder="$ "
          type="text"
          onChange={handleOnChange}
        />
        <FormInput
          required
          className="bg-transparent text-primary border-primary"
          controlId="max_price_filter"
          defaultValue={defaultMax}
          feedbackStyles="bg-white fs-5 fw-600 p-2"
          formGroupClassName="text-primary border-primary ms-5"
          label="Max $"
          placeholder="$ "
          type="text"
          onChange={handleOnChange}
        />
        <Button
          className="fw-400 rounded mb-10 ms-10 w-25 fs-7 fs-sm-8 text-uppercase"
          id="price_range_submit_button"
          type="submit"
          variant="primary"
        >
          GO
        </Button>
      </Form>
      {submitError && (
        <div
          className="bg-white text-danger fs-7 fs-sm-8 fw-600 mb-8"
          role="alert"
          type="invalid"
        >
          {submitError}
        </div>
      )}
    </>
  );
}

export default PriceRangeFilter;
